import { render } from "./AppFooter.vue?vue&type=template&id=6f28457d&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f28457d"]])

export default __exports__